import ReactGA from 'react-ga';

import { checkCookie } from './cookies';
import ANALYTICS_EVENTS from '../events';
import { COOKIES } from '../constants';

const { ANALYTICS } = COOKIES;

export const emitEvent = (event) => {
  if (checkCookie(ANALYTICS)) {
    ReactGA.event(event);
  }
};

export const EVENTS = ANALYTICS_EVENTS;
